import React from 'react';
import { Crosshair } from 'lucide-react';

const GAMES = [
  {
    id: 'spaceshooter',
    name: '小蜜蜂',
    description: '经典街机射击游戏',
    icon: Crosshair,
  },
];

const GameMenu = ({ isNight, onSelectGame, onClose }) => {
  const cardClass = isNight
    ? "bg-white/[0.07] backdrop-blur-xl rounded-2xl border border-white/[0.12] shadow-xl p-6"
    : "bg-white/70 backdrop-blur-md rounded-2xl border border-white/80 shadow-lg p-6";

  const btnClass = isNight
    ? "bg-white/5 border-slate-700/50 hover:bg-white/10 hover:border-slate-500"
    : "bg-slate-50/80 border-slate-200 hover:bg-white hover:border-slate-300";

  const btnIconBg = isNight
    ? "bg-cyan-500/20 border border-cyan-400/20"
    : "bg-cyan-100 border border-cyan-200";

  const iconColor = isNight ? 'text-cyan-300' : 'text-cyan-600';

  const playBadge = isNight
    ? "bg-green-500/20 text-green-300 border border-green-400/20"
    : "bg-green-100 text-green-700 border border-green-200";

  return (
    <div className={cardClass}>
      {/* Header row */}
      <div className="flex items-center justify-between mb-4">
        <h2 className={`text-lg font-bold ${isNight ? 'text-white' : 'text-slate-800'}`}>
          🎮 Games
        </h2>
        <button
          onClick={onClose}
          className={`text-sm px-3 py-1.5 rounded-lg transition-colors ${
            isNight
              ? 'text-white/50 hover:text-white hover:bg-white/10'
              : 'text-slate-400 hover:text-slate-700 hover:bg-slate-100'
          }`}
        >
          ← Back to Dashboard
        </button>
      </div>

      {/* Game list */}
      <div className="space-y-3">
        {GAMES.map(game => {
          const Icon = game.icon;
          return (
            <button
              key={game.id}
              onClick={() => onSelectGame(game.id)}
              className={`w-full flex items-center gap-4 p-4 rounded-xl border transition-all duration-200 hover:scale-[1.01] ${btnClass}`}
            >
              <div className={`p-3 rounded-xl ${btnIconBg}`}>
                <Icon size={24} className={iconColor} />
              </div>
              <div className="flex-1 text-left">
                <div className={`font-semibold ${isNight ? 'text-white' : 'text-slate-800'}`}>
                  {game.name}
                </div>
                <div className={`text-sm ${isNight ? 'text-white/50' : 'text-slate-400'}`}>
                  {game.description}
                </div>
              </div>
              <div className={`text-xs px-2 py-1 rounded ${playBadge}`}>
                PLAY
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default GameMenu;
